<template>
  <app-content>
    <form action="#">
      <div class="inner">
        <p class="buttons">
          <app-button-delete @click="deleteItem" v-if="!newItem" />
        </p>
        <app-content-title v-if="!newItem" :title="item.name" />
        <app-content-title v-if="newItem" :title="translations.newStationGroup" />
      </div>
      <app-tabs
          :shouldLoadFirstTab="newItem"
          :loadTab="params.tab"
          @appTabChanged="onAppTabChanged"
      >
        <div :title="translations.stationGroup">
          <app-settings @submit="submitForm" :disabled="pending">
            <app-settings-content>
              <app-settings-desc :title="translations.basicInfo">
                <p>
                  <translate>Založeno</translate>:<br />
                  <span v-html="formatDateAdvanced(item._created)" />
                </p>
                <p>
                  <translate>Počet stanic</translate>: {{ item.numberOfTvStations }}
                </p>
              </app-settings-desc>

              <app-settings-options>
                <app-settings-col class="field_left">
                  <app-input
                      required
                      :label="translations.name"
                      :error="errors.items.find(el => el.field === 'name')"
                      v-model="formItem.name"
                      name="name"
                  />

                  <app-checkbox
                      name="deviceVisibility"
                      :title="translations.deviceVisibility"
                      :error="!!errors.first('deviceVisibility')"
                      v-model="formItem.deviceVisibility"
                  />
                </app-settings-col>

                <app-settings-col class="field_right">
                  <app-input
                      :label="translations.order"
                      :error="errors.items.find(el => el.field === 'order')"
                      v-model="formItem.order"
                      name="order"
                      type="number"
                  />
                </app-settings-col>

                <app-settings-input
                    :error="errors.items.find(el => el.field === 'note')"
                    :label="translations.note"

                >
                  <app-textarea
                      v-model="formItem.note"
                      name="note"
                  />
                </app-settings-input>
              </app-settings-options>
            </app-settings-content>

            <app-settings-content v-if="deviceLanguages.length > 0">
              <app-settings-desc :title="translations.translations" />

              <app-settings-options>
                  <template v-for="(language, key) in deviceLanguages">
                      <app-settings-col :class="{ 'field_left': key%2 == 0, 'field_right': key%2 == 1 }">
                          <app-input
                              v-if="!newItem && formItem.translations[language.isoCode]"
                              required
                              :label="language.languageName"
                              :error="errors.items.find(el => el.field === 'translations' && el.inputField == language.isoCode)"
                              v-model="formItem.translations[language.isoCode]"
                              :name="`transObj-translations-${language.isoCode}`"
                          />
                          <app-input v-else
                              required
                              :label="language.languageName"
                              :error="errors.items.find(el => el.field === 'translations' && el.inputField == language.isoCode)"
                              :name="`transObj-translations-${language.isoCode}`"
                          />
                      </app-settings-col>
                  </template>
              </app-settings-options>
            </app-settings-content>

            <app-settings-buttons :navLinkTitle="translations.list" :nav-link-to="{ name: 'station-groups' }">
              <app-content-save-button :disabled="pending" @click="disallowBack" />
            </app-settings-buttons>
          </app-settings>
        </div>
        <div
          :title="translations.tvStations"
          :data-disabled-title="translations.tvStationsSaveStationGroupFirst"
          :data-disabled="!item || !item._id"
        >
          <TvStationBaseDetail :title="item.name" filterName = 'groups'/>
        </div>
      </app-tabs>
    </form>
  </app-content>
</template>

<script>
import getItemDetailMixin from 'mixins/getItemDetailMixin'
import appTitleMixin from 'mixins/appTitleMixin'
import formatDateMixin from 'mixins/formatDateMixin'
import TvStationBaseDetail from 'views/TvStationBaseDetail'
import {mapActions} from "vuex";

const itemDetailMixin = getItemDetailMixin({
  apiMethodsSuffix: 'TvStationGroup'
})

export default {
  name: 'station-group',
  mixins: [formatDateMixin, itemDetailMixin, appTitleMixin()],
  components: { TvStationBaseDetail },
  computed: {
    deviceLanguages()
    {
        return this.$store.state.languages.deviceLanguages;
    },
    translations() {
      return {
        translations: this.$gettext('Překlady'),
        deviceVisibility: this.$gettext('Viditelná na zařízení'),
        newStationGroup: this.$gettext('Nová skupina stanic'),
        stationGroup: this.$gettext('Skupina stanic'),
        basicInfo: this.$gettext('Základní údaje'),
        name: this.$gettext('Název'),
        order: this.$gettext('Pořadí'),
        note: this.$gettext('Poznámka'),
        list: this.$gettext('Seznam'),
        tvStations: this.$gettext('TV stanice'),
        tvStationsSaveStationGroupFirst: this.$gettext('TV stanice (nutné uložit skupinu stanic)')
      }
    },
    currentTitle() {
      return [
        { name: this.$gettext('Skupiny stanic'), link: { name: 'station-groups' } },
        this.item.name || this.$gettext('Nová skupina stanic')
      ]
    }
  },
  created() {
    this.params.tab = 0

    this.getDeviceLanguages({
        params: {
            languageId: this.$store.state.uiLanguages.currentLanguageId,
        }
    });
  },
  methods: {
    ...mapActions([
      'getDeviceLanguages',
    ]),
    getDeleteError(item) {
      if (item.numberOfTvStations !== 0) {
        return this.$gettext('Skupinu nelze smazat, protože obsahuje stanice.')
      }
      return null
    },
    shouldConfirmDelete() {
      return false
    }
  }
}
</script>
